// 个人信息管理
<template>
    <div class="info-container">
        <!-- 顶部导航栏 -->
        <div class="top-header">
            <div class="header-left" @click="goBack">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="header-center">
                <h3>Personal Center</h3>
            </div>
            <div class="header-right">
                <!-- 占位，保持布局平衡 -->
            </div>
        </div>

        <!-- 个人信息列表 -->
        <div class="info-section">
            <div class="info-content">
                <div class="info-list">
                    <!-- 账号 -->
                    <div class="info-item">
                        <div class="info-label">{{ $t('common.Account') }}</div>
                        <div class="info-value">{{ userInfo.account || userInfo.name }}</div>
                    </div>
                    
                    <!-- 手机号码 -->
                    <div class="info-item">
                        <div class="info-label">{{ $t('common.Phone') }}</div>
                        <div class="info-value-wrapper">
                            <div class="info-value">{{ userInfo.phone || '' }}</div>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                    
                    <!-- 公司名称 -->
                    <div class="info-item">
                        <div class="info-label">{{ $t('common.Company') }}</div>
                        <div class="info-value-wrapper">
                            <div class="info-value">{{ userInfo.type || ''}}</div>
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 退出登录按钮 -->
        <div :class="['logout-section', { 'safari-only': isSafari }]">
            <el-button type="primary" class="logout-btn" @click="handleLogout">{{ $t('common.quit') }}</el-button>
        </div>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    import cookieOperation from '../../common/js/cookieOperation';
    import sessionTimeout from '../../common/js/sessionTimeout';
    
    export default {
        data() {
            return {
                isSafari: false, // 是否为 Safari 浏览器
                // 用户信息
                userInfo: {
                    name: '',
                    account: '',
                    phone: '',
                    type: '',
                    dept: ''
                }
            };
        },
        methods: {
            // 返回
            goBack() {
                this.$router.push('/index');
            },
            // 获取个人信息
            getUserInfoByCondition() {
                let _this = this;
                util.publicget('/user/getUserInfoByCondition2', {
                    username: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        _this.userInfo.name = res.userName;
                        _this.userInfo.account = res.userName;
                        // 从API获取手机号和公司名称，如果API没有返回，则使用默认值
                        _this.userInfo.phone = res.phone || res.phoneNumber || '';
                        if(res.userType === 0){
                            _this.userInfo.type = 'employee';
                        }else if(res.userType === 1 || res.userType === 2){
                            _this.userInfo.type = 'manager';
                        }else if(res.userType === 3){
                            _this.userInfo.type = 'super_manager';
                        }else if(res.userType === 4){
                            _this.userInfo.type = 'vip_customer';
                        }
                        _this.userInfo.dept = res.userDept || sessionStorage.getItem('userDept') || '';
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 退出登录
            handleLogout() {
                this.$confirm(this.$t('common.confirmLogout'), this.$t('common.tip'), {
                    confirmButtonText: this.$t('common.confirm'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: 'warning',
                    center: true
                }).then(() => {
                    // 清除会话超时监控
                    sessionTimeout.destroy();
                    
                    // 清除cookie和sessionStorage
                    cookieOperation.cookie.delete('access_token');
                    cookieOperation.cookie.delete('userName');
                    cookieOperation.cookie.delete('userType');
                    cookieOperation.cookie.delete('userDept');
                    sessionStorage.clear();
                    
                    // 跳转到登录页
                    this.$router.push('/login');
                    this.$message({
                        type: 'success',
                        message: this.$t('common.logoutSuccess')
                    });
                }).catch(() => {
                    // 取消操作
                });
            }
        },
        mounted() {
            // 检测 Safari 浏览器
            this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            
            // 从sessionStorage获取基本信息
            this.userInfo.account = sessionStorage.getItem('userName') || '';
            this.userInfo.dept = sessionStorage.getItem('userDept') || '';
            this.userInfo.company = sessionStorage.getItem('userDept') || '';
            
            // 获取详细信息
            this.getUserInfoByCondition();
        }
    };
</script>

<style lang="scss">
    .info-container {
        width: 100%;
        height: 100vh;
        background-color: #f5f5f5;
        position: relative;
        overflow-x: hidden;
        overflow-y: auto; /* 避免 iOS Safari 100vh 裁切底部按钮 */
        -webkit-overflow-scrolling: touch;
        display: flex;
        flex-direction: column;
    }

    .top-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        background-color: #409EFF;
        padding: 0 15px;
        position: sticky;
        top: 0;
        z-index: 100;
        flex-shrink: 0;

        .header-left,
        .header-right {
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #fff;
            font-size: 20px;
            transition: opacity 0.3s;

            &:active {
                opacity: 0.7;
            }
        }

        .header-center {
            flex: 1;
            text-align: center;

            h3 {
                margin: 0;
                color: #fff;
                font-size: 18px;
                font-weight: 500;
            }
        }
    }

    .info-section {
        flex: 1;
        overflow-y: auto;
        padding: 12px;
        /* 默认底部 padding，为按钮区域预留基本空间 */
        padding-bottom: calc(12px + 80px + env(safe-area-inset-bottom, 0px));
        -webkit-overflow-scrolling: touch;
    }

    .info-content {
        width: 100%;
    }

    .info-list {
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 1px 2px rgba(0,0,0,0.08);
    }

    .info-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        border-bottom: 1px solid #f0f0f0;
        min-height: 50px;

        &:last-child {
            border-bottom: none;
        }
    }

    .info-label {
        font-size: 15px;
        color: #333;
        font-weight: 400;
        flex-shrink: 0;
    }

    .info-value {
        font-size: 15px;
        color: #333;
        text-align: right;
        flex: 1;
        margin-right: 8px;
    }

    .info-value-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex: 1;

        .info-value {
            margin-right: 8px;
        }

        .el-icon-arrow-right {
            color: #c0c4cc;
            font-size: 14px;
        }
    }

    .logout-section {
        padding: 20px 15px;
        /* 默认底部 padding，其他浏览器使用较小的值 */
        padding-bottom: 130px;
        background-color: #f5f5f5;
        flex-shrink: 0;
        overflow: visible; /* Safari 中 overflow: hidden 会截断底部按钮，改为 visible */

        &.safari-only {
            padding-bottom: 130px;
        }
    }

    .logout-btn {
        width: 100%;
        height: 45px;
        font-size: 16px;
        border-radius: 4px;
    }
    
    // 适配移动端样式
    @media screen and (max-width: 748px) {
        // 针对 iPhone Safari 的特殊处理
        @supports (-webkit-touch-callout: none) {
            .logout-section {
                /* Safari 浏览器需要更多的底部空间，确保按钮不被底部工具栏遮挡 */
                padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
            }
            
            .info-section {
                /* Safari 中确保内容区域也有足够的底部空间 */
                padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
            }
        }
        
        // 针对非 Safari 浏览器的优化，减少不必要的空白
        @supports not (-webkit-touch-callout: none) {
            .logout-section {
                /* 非 Safari 浏览器使用较小的底部 padding */
                padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));
            }
            
            .info-section {
                /* 非 Safari 浏览器使用较小的底部 padding */
                padding-bottom: calc(12px + 20px + env(safe-area-inset-bottom, 0px));
            }
        }
        
        // 针对 iOS 设备的特殊处理
        @media screen and (-webkit-min-device-pixel-ratio: 2) {
            .info-container {
                /* 使用 100dvh 代替 100vh，在 iOS Safari 中更准确 */
                height: 100dvh;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/phone/personalInfo.vue